export enum Portal {
  PHILIPPINES = 'Philippines',
  USA = 'USA',
  INTERNATIONAL = 'International',
  DEFAULT = 'Global',
  MONTESSORI = 'Montessori',
}

export enum PortalType {
  COUNTRY = 'country',
  CURRICULUM = 'curriculum',
}

export const PortalLink = {
  [Portal.PHILIPPINES]: '/ph',
  [Portal.USA]: '/us',
  [Portal.INTERNATIONAL]: '/ib',
  [Portal.DEFAULT]: '/gb',
};
